import type { OrderAdminNoteAdminType } from '@/features/order/domain/enums/OrderAdminNoteAdminType'

export class CreateUpdateNoteEntity {
  id?: string
  note?: string
  adminType?: OrderAdminNoteAdminType
  orderId?: string
}
